import { FC, PropsWithChildren } from 'react'
import { twMerge } from 'tailwind-merge'
import { SIDE_MENU_PADDING } from '../../../constants/style-constants'

interface SettingsTitleProps {
  children: React.ReactNode
  onBack?: () => void
}

export const SettingsTitle: FC<PropsWithChildren<SettingsTitleProps>> = ({ children, onBack }) => (
  <div
    className={twMerge(
      'bg-brand-primary-subtle text-text-primary border-text-secondary/30 flex items-center gap-1.5 border-b font-semibold',
      SIDE_MENU_PADDING,
    )}
  >
    {onBack && (
      <button onClick={onBack}>
        <i className="fas fa-arrow-left text-text-primary" />
      </button>
    )}
    {children}
  </div>
)
